import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import {
  chinaContract,
  NftPurchaseContract,
} from "../../utils/contractHelpers";
import { useWeb3React } from "../useWagmiCompat";
import Environment from "../../utils/Environment";
import { enrichRoundWithKind } from "../../utils/roundKind";
import Web3 from "web3";

const TimerNft = () => {
  const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress = Environment.nftPurchase;
  const contract = NftPurchaseContract(tokenAddress, web3);

  const timerNft = useCallback(
    async (e) => {
      try {
        const buy = await contract.methods.rounds(e).call();
        return enrichRoundWithKind(buy);
      } catch (error) {
        throw error;
      }
    },
    [contract, account, web3],
  );
  return { timerNft: timerNft };
};
export default TimerNft;
